<!-- 我向市长说句话 -->
<template>
    <div class='event_contaniner box box_v'>
        <!--上面-->
        <div class="box_f2 box" style="marginBottom:10px;">
            <!--事件列表-->
            <left1 class="box_f1" style="marginRight:10px;" :show="show"></left1>
            <middle1 class="box_f2" style="margin:0 10px;"></middle1>
            <div class="box_f1 box box_v" style="marginLeft:10px;">
               <right1 class="box_f1"></right1>
               <right2 class="box_f1"></right2>
            </div>
        </div>
        <!--下面-->
        <div class="box_f1 box" style="marginTop:10px;">
            <left2 class="box_f1" style="marginRight:10px;"></left2>
            <middle2 class="box_f2" style="margin:0 10px;"></middle2>
            <right3  class="box_f1" style="marginLeft:10px;"></right3>
        </div>
      
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import left1 from './left1'
import left2 from './left2'
import middle1 from './middle1'
import middle2 from './middle2'
import right1 from './right1'
import right2 from './right2'
import right3 from './right3'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {left1,left2,middle1,middle2,right1,right2,right3},
    data() {
    //这里存放数据
        return {

        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.event_contaniner{
    width:100%;
    height:100%;
    display: flex;
}
</style>